// extracted by mini-css-extract-plugin
module.exports = {"sidebarContainer":"sidebar_sidebarContainer__2zYpv","sidebar":"sidebar_sidebar__31pwV","fade-in":"sidebar_fade-in__1C5Fr"};